import axios from 'axios';
import { charsheetAPI } from '../globals.js';

// Returns { presignedUrl, publicUrl } for uploading a campaign rule file
const getUploadUrl = async (campaignName, filename, filetype) => {
    const API_URL = `${charsheetAPI}?TableName=campaign-rules-upload&campaign=${campaignName}&filename=${encodeURIComponent(filename)}&filetype=${encodeURIComponent(filetype)}`;
    try {
        const res = await axios.get(API_URL, { withCredentials: true });
        return res.data;
    } catch (error) {
        console.error('Error getting upload URL:', error);
        return null;
    }
};

export default getUploadUrl;
